// Mock data for SimplySitter US — frontend only.

export const BRAND = {
  name: "SimplySitter",
  domain: "simplysitter.us",
  price: "$15.99",
  freeTrial: "1 month free",
};

export const SERVICES = [
  { id: "nanny", label: "Nanny", icon: "Baby", note: "Nanny also includes Newborn Care Specialist (newborn care)." },
  { id: "babysitter", label: "Babysitter", icon: "Clock", note: "Occasional, evening or weekend care." },
  { id: "housekeeper", label: "Housekeeper", icon: "Sparkles", note: "Regular, one-time or deep cleaning." },
  { id: "senior", label: "Senior care", icon: "HeartHandshake", note: "Compassionate daily companionship and support." },
];

export const TRUST_BADGES = [
  { icon: "HeartPulse", label: "First-aid / CPR trained" },
  { icon: "FileCheck2", label: "References checked" },
  { icon: "ShieldCheck", label: "Background check" },
];

export const STATS = [
  { icon: "Users", value: "8,500+", label: "families trust us" },
  { icon: "ShieldCheck", value: "100%", label: "vetted caregivers" },
  { icon: "MapPin", value: "15+", label: "cities across the US" },
];

export const FEATURES = [
  { icon: "ShieldCheck", title: "Verified & Trusted", text: "Every candidate verifies their identity before joining." },
  { icon: "UserCheck", title: "Interviewed", text: "We personally interview applicants before approving profiles." },
  { icon: "FileCheck2", title: "Background Checked", text: "Background and reference checks help families hire with confidence." },
];

export const CATEGORIES = [
  { id: "nanny", icon: "Baby", title: "Nannies", text: "Full-time, part-time or live-in care." },
  { id: "babysitter", icon: "Clock", title: "Babysitters", text: "Occasional, evening or weekend care." },
  { id: "housekeeper", icon: "Sparkles", title: "Housekeepers", text: "Regular, one-time or deep cleaning." },
  { id: "senior", icon: "HeartHandshake", title: "Senior care", text: "Compassionate daily companionship and support." },
];

export const STEPS = [
  { n: 1, title: "Post a job and tell us your needs", text: "Create your job in minutes and tell us exactly what you're looking for." },
  { n: 2, title: "Receive applications from checked candidates", text: "Receive applications only from experienced, background-checked candidates." },
  { n: 3, title: "Hire & download employment documents", text: "Choose your preferred candidate and download the required documents." },
];

export const BENEFITS = [
  "Only experienced caregivers",
  "English-speaking \u2013 other languages on request (good communication matters)",
  "First-aid / CPR training is a must",
  "Identity verified & background checked",
  "References are checked too",
  "Personal support \u2013 always here for you",
];

export const TESTIMONIALS = [
  {
    quote: "We found a wonderful nanny in less than a week. The process was simple and we felt safe the entire time.",
    name: "Laura M.",
    city: "New York",
    avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
  {
    quote: "Our housekeeper is amazing! Reliable, thorough and always on time. Highly recommend.",
    name: "Marco & Julia",
    city: "Chicago",
    avatar: "https://images.unsplash.com/photo-1625241152315-4a698f74ceb7?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
  {
    quote: "SimplySitter gave us the confidence that every person is vetted. Great platform!",
    name: "Sophie R.",
    city: "Los Angeles",
    avatar: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
];

export const TRUST_AVATARS = [
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&w=120&q=85",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=120&q=85",
  "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?crop=entropy&cs=srgb&fm=jpg&w=120&q=85",
];

export const HERO_IMAGE = "https://images.pexels.com/photos/8612920/pexels-photo-8612920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=940";

export const CAREGIVER_IMAGE = "https://images.unsplash.com/photo-1765896387398-1e1ae8d2eb85?crop=entropy&cs=srgb&fm=jpg&w=900&q=85";

export const ABOUT_IMAGE = "https://images.pexels.com/photos/6974489/pexels-photo-6974489.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940";

export const FAMILY_IMAGE = "https://images.pexels.com/photos/6974748/pexels-photo-6974748.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800";

export const FAQS = [
  { q: "How does the free trial work?", a: "Post your first job and try SimplySitter free for one month. After the trial it's just $15.99/month, and you can cancel anytime before renewal at no charge." },
  { q: "Are the candidates really vetted?", a: "Yes. Every caregiver verifies their identity, is personally interviewed, and passes background and reference checks before they can apply to your job." },
  { q: "When will I be charged?", a: "You won't be charged during your 1-month free trial. Billing of $15.99/month begins only after the trial ends, and we'll remind you beforehand." },
  { q: "Can I post more than one job?", a: "Absolutely. Your membership lets you post multiple jobs across different services and locations at no extra cost." },
  { q: "Can I cancel anytime?", a: "Yes, you can cancel your membership at any time from your account settings \u2014 no questions asked and no cancellation fees." },
  { q: "How do I contact support?", a: "Our support team is available by email and chat. Just tap 'Need help?' at the top of the page and we'll get back to you quickly." },
];

export const CITIES = [
  { name: "New York", state: "NY", slug: "new-york" },
  { name: "Los Angeles", state: "CA", slug: "los-angeles" },
  { name: "Chicago", state: "IL", slug: "chicago" },
  { name: "Houston", state: "TX", slug: "houston" },
  { name: "Phoenix", state: "AZ", slug: "phoenix" },
  { name: "Philadelphia", state: "PA", slug: "philadelphia" },
  { name: "San Diego", state: "CA", slug: "san-diego" },
  { name: "Dallas", state: "TX", slug: "dallas" },
  { name: "San Francisco", state: "CA", slug: "san-francisco" },
  { name: "Seattle", state: "WA", slug: "seattle" },
  { name: "Boston", state: "MA", slug: "boston" },
  { name: "Denver", state: "CO", slug: "denver" },
  { name: "Miami", state: "FL", slug: "miami" },
  { name: "Tampa", state: "FL", slug: "tampa" },
  { name: "Washington", state: "DC", slug: "washington" },
];

export const CITY_SEO = {
  "new-york": {
    intro: "From the Upper West Side to Brooklyn Heights, NYC families rely on SimplySitter to find dependable childcare that fits busy city schedules. Every nanny, babysitter and housekeeper is identity-verified, interviewed and background-checked \u2014 so you can hire with confidence in the city that never sleeps.",
    stats: { families: "2,400+", caregivers: "1,150+", avgRate: "$28/hr", response: "under 24h" },
    neighborhoods: ["Manhattan", "Brooklyn", "Queens", "Upper West Side", "Williamsburg", "Park Slope"],
  },
  "los-angeles": {
    intro: "Across LA's sprawling neighborhoods \u2014 from Santa Monica to Pasadena \u2014 SimplySitter helps families find vetted nannies, sitters and housekeepers without the endless scrolling. Our caregivers are experienced, first-aid trained and reference-checked for total peace of mind.",
    stats: { families: "1,900+", caregivers: "980+", avgRate: "$26/hr", response: "under 24h" },
    neighborhoods: ["Santa Monica", "Pasadena", "Silver Lake", "Culver City", "Sherman Oaks", "Venice"],
  },
  "chicago": {
    intro: "Chicago families in Lincoln Park, Wicker Park and the suburbs trust SimplySitter for reliable, background-checked care all year round \u2014 through every polar vortex and lakefront summer. Post your job free and receive applications only from vetted caregivers.",
    stats: { families: "1,400+", caregivers: "720+", avgRate: "$24/hr", response: "1\u20132 days" },
    neighborhoods: ["Lincoln Park", "Wicker Park", "Lakeview", "Hyde Park", "Naperville", "Oak Park"],
  },
  "houston": {
    intro: "In Houston, from The Heights to Sugar Land, growing families count on SimplySitter to connect with experienced nannies and housekeepers. Each candidate is interviewed and background-checked so you can focus on what matters most.",
    stats: { families: "1,100+", caregivers: "610+", avgRate: "$22/hr", response: "1\u20132 days" },
    neighborhoods: ["The Heights", "Montrose", "Sugar Land", "Katy", "The Woodlands", "Bellaire"],
  },
  "phoenix": {
    intro: "Valley families across Phoenix, Scottsdale and Tempe use SimplySitter to find trusted childcare and household help fast. Our caregivers are vetted, first-aid trained and ready to support your family through the busy Arizona seasons.",
    stats: { families: "820+", caregivers: "430+", avgRate: "$21/hr", response: "1\u20132 days" },
    neighborhoods: ["Scottsdale", "Tempe", "Chandler", "Gilbert", "Arcadia", "Mesa"],
  },
  "philadelphia": {
    intro: "From Center City to the Main Line, Philadelphia families choose SimplySitter for carefully vetted nannies, sitters and housekeepers. Post a job for free and connect with reference-checked candidates who know the city.",
    stats: { families: "980+", caregivers: "520+", avgRate: "$23/hr", response: "1\u20132 days" },
    neighborhoods: ["Center City", "Fishtown", "Main Line", "Chestnut Hill", "Manayunk", "South Philly"],
  },
  "san-diego": {
    intro: "San Diego families from La Jolla to North Park rely on SimplySitter for dependable, background-checked care. Whether it's a full-time nanny or occasional weekend babysitting, our vetted caregivers make hiring simple and safe.",
    stats: { families: "760+", caregivers: "410+", avgRate: "$25/hr", response: "1\u20132 days" },
    neighborhoods: ["La Jolla", "North Park", "Encinitas", "Carlsbad", "Coronado", "Pacific Beach"],
  },
  "dallas": {
    intro: "Dallas\u2013Fort Worth families in Highland Park, Plano and beyond trust SimplySitter for experienced, vetted caregivers. Every nanny, babysitter and housekeeper is interviewed and background-checked before applying to your job.",
    stats: { families: "1,050+", caregivers: "560+", avgRate: "$23/hr", response: "1\u20132 days" },
    neighborhoods: ["Highland Park", "Plano", "Frisco", "Uptown", "Las Colinas", "Lakewood"],
  },
  "san-francisco": {
    intro: "Bay Area families from the Marina to the Peninsula depend on SimplySitter for premium, thoroughly vetted childcare and household help. Our caregivers are experienced, first-aid trained and reference-checked \u2014 hiring made safe and simple.",
    stats: { families: "1,300+", caregivers: "640+", avgRate: "$32/hr", response: "under 24h" },
    neighborhoods: ["Marina", "Noe Valley", "Pacific Heights", "Mission", "Palo Alto", "Berkeley"],
  },
  "seattle": {
    intro: "Seattle families across Capitol Hill, Ballard and the Eastside choose SimplySitter for reliable, background-checked care rain or shine. Post your job free and hear only from experienced, vetted caregivers.",
    stats: { families: "890+", caregivers: "470+", avgRate: "$27/hr", response: "under 24h" },
    neighborhoods: ["Capitol Hill", "Ballard", "Bellevue", "Queen Anne", "Fremont", "Redmond"],
  },
  "boston": {
    intro: "Greater Boston families from Beacon Hill to Cambridge trust SimplySitter for vetted nannies, sitters and housekeepers. Each candidate is identity-verified and reference-checked so you can hire with confidence.",
    stats: { families: "1,020+", caregivers: "540+", avgRate: "$27/hr", response: "under 24h" },
    neighborhoods: ["Beacon Hill", "Cambridge", "Back Bay", "Brookline", "Somerville", "Newton"],
  },
  "denver": {
    intro: "Denver and Front Range families use SimplySitter to find dependable, background-checked care for every season. Our vetted caregivers are experienced, first-aid trained and ready to help your family thrive at altitude.",
    stats: { families: "680+", caregivers: "360+", avgRate: "$24/hr", response: "1\u20132 days" },
    neighborhoods: ["Cherry Creek", "Washington Park", "Highlands", "Boulder", "Littleton", "Aurora"],
  },
  "miami": {
    intro: "Miami families from Coral Gables to Brickell rely on SimplySitter for trusted, bilingual-friendly childcare and household help. Every caregiver is interviewed and background-checked \u2014 hiring made easy under the Florida sun.",
    stats: { families: "940+", caregivers: "500+", avgRate: "$23/hr", response: "1\u20132 days" },
    neighborhoods: ["Coral Gables", "Brickell", "Coconut Grove", "Aventura", "Kendall", "Doral"],
  },
  "tampa": {
    intro: "Tampa Bay families from South Tampa to St. Petersburg choose SimplySitter for reliable, vetted nannies, sitters and housekeepers. Post a job for free and connect with experienced, background-checked caregivers nearby.",
    stats: { families: "560+", caregivers: "300+", avgRate: "$21/hr", response: "1\u20132 days" },
    neighborhoods: ["South Tampa", "St. Petersburg", "Westchase", "Carrollwood", "Brandon", "Wesley Chapel"],
  },
  "washington": {
    intro: "Families across the DC metro \u2014 from Capitol Hill to Arlington and Bethesda \u2014 trust SimplySitter for thoroughly vetted childcare and household help. Our caregivers are experienced, first-aid trained and reference-checked.",
    stats: { families: "1,080+", caregivers: "570+", avgRate: "$26/hr", response: "under 24h" },
    neighborhoods: ["Capitol Hill", "Georgetown", "Arlington", "Bethesda", "Dupont Circle", "Alexandria"],
  },
};

export const POPULAR = [
  { label: "Nanny New York", slug: "new-york" },
  { label: "Babysitter Chicago", slug: "chicago" },
  { label: "Housekeeper Los Angeles", slug: "los-angeles" },
  { label: "Senior care Miami", slug: "miami" },
];
